import React, { ReactElement } from "react";
import { connect, FormikContextType } from "formik";
import { InkomenEnFiscusState, AOWSyncHeightIndex } from "../infra/inkomen-en-fiscus-schema";
import {
  LabeledCurrencyInput,
  LabeledNumberInput,
  LabeledBerekenDate,
  SyncMultipleHeightProps,
  SyncHeight
} from "adviesbox-shared";

const Aanvrager2AOW = ({
  targetRef,
  sourceRef
}: SyncMultipleHeightProps & {
  formik: FormikContextType<InkomenEnFiscusState>;
}): ReactElement => {
  return (
    <SyncHeight
      sourceRef={sourceRef && sourceRef[AOWSyncHeightIndex.All]}
      targetRef={targetRef && targetRef[AOWSyncHeightIndex.All]}
    >
      <LabeledCurrencyInput caption="AOW bedrag" name="aanvrager2Aow.bedrag" readonly={true} />
      <SyncHeight
        sourceRef={sourceRef && sourceRef[AOWSyncHeightIndex.Korting]}
        targetRef={targetRef && targetRef[AOWSyncHeightIndex.Korting]}
      >
        <LabeledNumberInput
          caption="Korting AOW"
          name="aanvrager2Aow.korting"
          appendChildren={<span className="MiniLabel">Jaar</span>}
        />
      </SyncHeight>
      <SyncHeight
        sourceRef={sourceRef && sourceRef[AOWSyncHeightIndex.Ingangsdatum]}
        targetRef={targetRef && targetRef[AOWSyncHeightIndex.Ingangsdatum]}
      >
        <LabeledBerekenDate caption="Ingangsdatum AOW" name="aanvrager2Aow.ingangsdatum" />
      </SyncHeight>
    </SyncHeight>
  );
};

export default connect<SyncMultipleHeightProps, InkomenEnFiscusState>(Aanvrager2AOW);
